import React, { useState, useMemo } from 'react';
import UserName from '../../Comman Components/UserName';
import Images from '../../Comman Components/Images';
import moment from 'moment';
import defaultPreviewPlaceholder from '../../Assets/dummy_images/default-preview-placeholder.webp';

export default function YoutubeModal({ Previewimages: mediaItems = [], Previewcaptions = '', profile, title }) {
  const [open, setOpen] = useState(true);

  const videoItem = useMemo(
    () => mediaItems.find(item => item.type === 'video'),
    [mediaItems]
  );

  const videoUrl = videoItem?.permanentUrl || videoItem?.localUrl;

  const renderMedia = () => {
    if (!videoUrl) {
      return (
        <img
          src={defaultPreviewPlaceholder}
          alt="Default preview"
          className="w-full h-auto max-h-72 object-cover"
        />
      );
    }

    return (
      <video
        src={videoUrl}
        controls
        className="w-full h-auto max-h-72 object-contain bg-black"
      />
    );
  };

  return (
    <div className="w-full max-w-md mx-auto my-4 border border-gray-300 rounded-xl">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between p-3 font-semibold text-left"
      >
        <div className="flex items-center gap-2">
          <i className="fa-brands fa-youtube text-red-600 text-lg"></i>
          <span>YouTube</span>
        </div>
        <i className={`fa ${open ? "fa-angle-up" : "fa-angle-down"} text-gray-400`}></i>
      </button>

      {open && (
        <div className="border-t border-gray-200">
          {renderMedia()}

          <div className="p-4 space-y-3">
            <h3 className="font-bold text-lg text-gray-900 break-words">
              {title || <span className="text-gray-400 italic">Your video title will appear here...</span>}
            </h3>

            <div className="flex items-center gap-3">
              <div className="w-10 h-10">
                {profile ? (
                  <Images Id={profile.platform_id} />
                ) : (
                  <img
                    src={defaultPreviewPlaceholder}
                    alt="Default profile"
                    className="w-10 h-10 rounded-full object-cover"
                  />
                )}
              </div>
              <div>
                <div className="font-semibold text-sm">
                  {profile ? <UserName Id={profile.platform_id} /> : "YouTube Channel"}
                </div>
                <div className="text-xs text-gray-500">
                  <span>{moment().format("MMM D, YYYY")}</span>
                </div>
              </div>
            </div>

            <div className="bg-gray-100 p-3 rounded-lg mt-2">
              <p className="text-sm text-gray-700 whitespace-pre-wrap">
                {Previewcaptions || (
                  <span className="text-gray-400 italic">Your video description will appear here...</span>
                )}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}